export default __webpack_public_path__ + "static/media/Order_02.a6b2dd1e.png";